<div class="mandala-icons">
  <button type="button" class="icon-btn" (click)="openSettings.emit()" aria-label="Mandala settings">⚙</button>
</div>
